import { useEffect, useRef } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { InsuranceWithBilling } from "shared";
import { useIsPolicyHolder } from "../../app/Providers/PolicyContext";
import {
  useLogHasOutstandingBalance,
  useLogIsPolicyHolder,
} from "../../app/Providers/LogOnReadyContext";

export const useInsuranceWithBilling = () => {
  const initialized = useRef(false);
  const { setIsPolicyHolder } = useIsPolicyHolder();
  const logIsPolicyHolder = useLogIsPolicyHolder();
  const logHasOutstandingBalance = useLogHasOutstandingBalance();

  const { data: insuranceWithBilling } = useFetchApi<InsuranceWithBilling>(
    "insurance-billing",
    2
  );

  const { policies } = insuranceWithBilling;
  const hasPolicies = policies.length > 0;

  useEffect(() => {
    // Policies are only loaded once, so run this effect once after policies are loaded.
    if (!initialized.current) {
      setIsPolicyHolder(hasPolicies);
      logIsPolicyHolder(hasPolicies);
      initialized.current = true;
    }
  }, [hasPolicies, logIsPolicyHolder, setIsPolicyHolder]);

  const hasOutstandingBalance =
    insuranceWithBilling.billing.status === "success"
      ? insuranceWithBilling.billing.amount > 0
      : false;

  useEffect(() => {
    logHasOutstandingBalance(hasOutstandingBalance);
  }, [hasOutstandingBalance, logHasOutstandingBalance]);

  return insuranceWithBilling;
};
